/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type UserCell_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Users_lists$ref: FragmentReference;
declare export opaque type Users_lists$fragmentType: Users_lists$ref;
export type Users_lists = {|
  +id: string,
  +usersByEmail: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: UserCell_user$ref,
      |}
    |}>
  |},
  +$refType: Users_lists$ref,
|};
export type Users_lists$data = Users_lists;
export type Users_lists$key = {
  +$data?: Users_lists$data,
  +$fragmentRefs: Users_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "email",
      "type": "String!"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "usersByEmail"
        ]
      }
    ]
  },
  "name": "Users_lists",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "usersByEmail",
      "args": [
        {
          "kind": "Variable",
          "name": "email",
          "variableName": "email"
        }
      ],
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "__Users_usersByEmail_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserCell_user"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Lists"
};
})();
// prettier-ignore
(node/*: any*/).hash = '90d8644d4fb0fb2ce01c1f50fdcefc4e';

module.exports = node;
